<template>
  <div class="detail-info">
    <div class="head">套餐订单编号：{{ detail.insOrderId }}</div>
    <div class="main">
      <Form :label-width="120">
        <Row>
          <FormItem label="套餐名称:" style="width: 33%">
            {{ detail.classroomName }}</FormItem>
          <FormItem label="学校:" style="width: 33%">
            {{ detail.schoolName }}</FormItem>
          <FormItem label="家长手机:" style="width: 33%">
            {{ detail.phoneNo }}</FormItem>
        </Row>
        <Row>
          <FormItem label="学期:" style="width: 33%">
            {{ detail.termName }}</FormItem>
          <FormItem label="学生:" style="width: 33%">
            {{ detail.studentName }}</FormItem>
          <FormItem label="年级班级:" style="width: 33%">
            {{ detail.gradeClassName }}</FormItem>
        </Row>
        <Row>
          <FormItem label="套餐金额:" style="width: 33%">
            {{ detail.offerFeeSum | feetoFixedTwo() }}</FormItem>
          <FormItem label="实付金额:" style="width: 33%">
            {{ detail.chargeFee | feetoFixedTwo() }}</FormItem>
          <FormItem label="优惠合计:" style="width: 33%">
            {{ detail.discFee | feetoFixedTwo() }}</FormItem>
        </Row>
        <Row>
          <FormItem label="交易流水号:" style="width: 33%">
            {{ detail.payNo }}</FormItem>
        </Row>
      </Form>
    </div>
  </div>
</template>

<script>
import { numsFilter } from '@/mixins/mixins';
export default {
  mixins: [numsFilter],
  props: {
    detail: {
      type: Object,
      default: () => null
    }
  },
  data() {
    return {

    };
  }

};
</script>

<style lang="scss" scoped>
.detail-info {
  width: 100%;
  border: rgb(247, 248, 250) 2px solid;
  border-radius: 8px;
  margin-bottom: 32px;
  .head {
    background: rgb(247, 248, 250);
    line-height: 40px;
    font-weight: 700;
    padding: 0 20px;
  }
}
.main{
  padding-top: 20px;
  /deep/.ivu-form-item{
    margin-bottom: 10px;
  }
  /deep/.ivu-form .ivu-form-item-label{
    color: #a8a6a5;
  }
}
</style>
